import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { IApiPagination } from "../../../interfaces/IPagination";
import {
  DealerInterface,
  GetDealersResponse,
  TDealerFilter,
} from "../../../interfaces/dealerInterface";
import axiosTeethTab from "../../../services/apiCall";

type DealerApiInterface = {
  getDealers: (
    filter: TDealerFilter,
    pagination: IApiPagination,
  ) => Promise<ApiResponse<GetDealersResponse>>;
  saveDealer: (dealer: DealerInterface) => Promise<ApiResponse<DealerInterface>>;
  getDealerById: (id: string) => Promise<ApiResponse<DealerInterface>>;
  enable: (id: string) => Promise<ApiResponse<DealerInterface>>;
  disable: (id: string) => Promise<ApiResponse<DealerInterface>>;
  exportData: () => Promise<Blob>;
};

export const dealerApi: DealerApiInterface = {
  getDealers: async (filter, pagination) => {
    return await axiosTeethTab.get("dealers/filter", {
      params: { filter, pagination },
    });
  },
  saveDealer: async (dealer) => {
    const endpoint = dealer._id ? `dealers/${dealer._id}` : "dealers";
    return await axiosTeethTab.post<DealerInterface>(endpoint, dealer);
  },
  getDealerById: async (id: string) => {
    return await axiosTeethTab.get<DealerInterface>(`dealers/${id}`);
  },
  enable: async (id: string) => {
    return await axiosTeethTab.patch<DealerInterface>(`dealers/${id}/enable`);
  },
  disable: async (id: string) => {
    return await axiosTeethTab.patch<DealerInterface>(`dealers/${id}/disable`);
  },
  exportData: async () => {
    const response = await axiosTeethTab.get("dealers/export-excel", {
      responseType: "blob",
    });
    return response.data as Blob;
  },
};
